import React from "react";
import './style.css'

const WalletPopup = ({ handleCancel, handleRedirect,title, btntitle }) => {
  return (
    <div className="popup-overlay wallet_container_popup">
      <div
        className="popup-content"
      >
       <div className="wallet_container_popup_content">
       <div className="wallet_container_popup_title">
          <h2 className="popup-title">Alert !</h2>
          <p>{title || "Insufficient Balance! Please Add Money To Wallet"}</p>
        </div>
        <div
          className="wallet_container_popup_button"
        >
          <button
            type="button"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleRedirect}
          >
            {btntitle || "Add Money To Wallet"}
          </button>
        </div>
       </div>
      </div>
    </div>
  );
};

export default WalletPopup;
